import React, { useState } from "react"
import { Badge, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import PerfectScrollbar from "react-perfect-scrollbar"
import { useQuery } from "@apollo/react-hooks"
import { SHOPPING_CART } from "../../gql"

const ShoppingCartDropdown = ({ history, isIE }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { data } = useQuery(SHOPPING_CART, {
    fetchPolicy: "network-only"
  })

  return (
    <Dropdown nav inNavbar isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle nav caret>
        <i className="fas fa-shopping-cart" />

        {isIE && data?.shoppingCart?.orderDetails?.length > 0 && (
          <div className="notify-ie"></div>
        )}

        {!isIE && data?.shoppingCart?.orderDetails?.length > 0 && (
          <div className="notify">
            {" "}
            <span className="heartbit" /> <span className="point" />{" "}
          </div>
        )}
      </DropdownToggle>
      <DropdownMenu right className="mailbox">
        {!data?.shoppingCart?.orderDetails ? (
          <div className="p-4 text-dark border-bottom">
            <h6 className="mb-0 font-medium">您的購物車沒有商品</h6>
          </div>
        ) : (
          <div className="p-4 text-dark border-bottom">
            <h6 className="mb-0 font-medium">
              您的購物車有 {data.shoppingCart.orderDetails.length} 項商品
            </h6>
          </div>
        )}
        <div
          className="message-center notifications"
          style={{ maxHeight: "350px" }}
        >
          {data?.shoppingCart?.orderDetails?.length > 0 && (
            <PerfectScrollbar>
              {data.shoppingCart.orderDetails.map((item, index) => (
                <div
                  className="message-item"
                  key={index}
                  onClick={() => {
                    history.push("/shoppingcart")
                    setIsOpen(!isOpen)
                  }}
                >
                  <span className="user-img">
                    <img
                      src={
                        item.product.photoUrl
                          ? `http://${item.product.photoUrl}`
                          : "http://bit.ly/28Y6Apr"
                      }
                      alt="商品"
                      className=""
                      width=""
                    />
                  </span>
                  <div className="mail-contnet">
                    <p className="mb-1" style={{ fontSize: "14px" }}>
                      品名：{item.product.name}
                    </p>
                    <span className="mail-desc">
                      數量：{item.quantity}
                      單價：
                      {item.unitPrice ? (
                        `NT$ ${item.unitPrice
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
                      ) : (
                        <Badge
                          color="info"
                          style={{
                            position: "relative",
                            fontSize: "12px"
                          }}
                        >
                          <strong>待業務報價</strong>
                        </Badge>
                      )}
                    </span>
                  </div>
                </div>
              ))}
            </PerfectScrollbar>
          )}
        </div>
        <a
          className="nav-link text-center link text-muted unselectable pointer"
          onClick={() => {
            history.push("/shoppingcart")
            setIsOpen(!isOpen)
          }}
        >
          <b>查看購物車詳情</b> <i className="fa fa-angle-right" />
        </a>
      </DropdownMenu>
    </Dropdown>
  )
}

export default ShoppingCartDropdown
